import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FlightLogHttpClient } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.service';

@Injectable()
export class FlightLogActiveGuard {
  constructor(private flightLogService: FlightLogHttpClient) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const id = route.params.id;
    return this.flightLogService.isActive(id);
  }
}
